import { Combobox, ComboboxOption, Input, spaceMixin, token } from '@zillow/constellation';
import styled from 'styled-components';

export const StyledCombobox = styled(Combobox)`
  label {
    padding: ${spaceMixin('xs')} !important;
    min-width: 33px;
  }

  svg {
    height: 16px !important;
    width: 16px !important;
  }

  section {
    // Embeds the property result list since used in the filters popover
    position: relative !important;
    box-shadow: none !important;
    border-radius: none !important;
    transform: translate3d(0px, 8px, 0px) !important;
    padding-bottom: ${spaceMixin('sm')};

    ul {
      border: none !important;
      border-radius: none !important;
      max-height: 242px !important;
    }
  }
`;

export const StyledComboboxOption = styled(ComboboxOption)`
  div {
    white-space: pre;
    color: ${token('colors.textMedium')};
  }

  div::first-line {
    color: ${token('colors.textDark')};
  }
`;

export const StyledInput = styled(Input)`
  padding: ${spaceMixin('xs')} 0 ${spaceMixin('xs')} 0 !important;
  font-weight: 400 !important;
`;
